import { ChequeDepositsFilters } from '@/state/reducers/chequeDepositReducer'
import { axios, getConfigs, IRequestConfig } from './api'
import {
  CreateChequeDepositDto,
  ChequeDepositDto,
  UpdateChequeDepositDto,
  UpdateChequeDto,
} from './dtos'
import { PaginatedDto } from './extendedType'

export class ChequeDepositService {
  private static readonly endpoint = 'cheque-deposit'

  static getAll(
    query: ChequeDepositsFilters,
  ): Promise<PaginatedDto<ChequeDepositDto>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        {},
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }

  static create(dto: CreateChequeDepositDto): Promise<ChequeDepositDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.endpoint,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static update(
    id: number,
    dto: UpdateChequeDepositDto,
  ): Promise<ChequeDepositDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static updateCheque(
    id: number,
    chequeId: number,
    dto: UpdateChequeDto,
  ): Promise<ChequeDepositDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        `${this.endpoint}/${id}/cheque/${chequeId}`,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static remove(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }
}
